import axios from "axios";
import { useCombinedStore } from "../store";
import { resolverEnderecoDaApi } from "./enderecoApi.service";

// O baseURL era lido do zustand uma vez, no import, e ficava vazio quando
// ninguém tinha escolhido a loja ainda — as chamadas saíam relativas à página.
// Agora cai para REACT_APP_API_URL, que é como a instância de nuvem sobe já
// apontando para o alfredo-ops-api.
const api = axios.create({
  baseURL: resolverEnderecoDaApi(
    useCombinedStore.getState().subsidiaryDataZustand?.subsidiaryVirtualAddress
  ),
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = useCombinedStore.getState().authUserZustand?.authUser;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (error.code === "ERR_NETWORK") {
      useCombinedStore.getState().removeAuthUserZustand();
      useCombinedStore
        .getState()
        .setMessageZustand(
          "Tempo de Inatividade atingido, realize o login novamente.",
          "error"
        );
      window.location.href = "/";
    } else if (response) {
      // Lidar com erros de resposta do servidor
      if (response.status === 400) {
        // Exibir mensagem amigável para erros 400
        console.log(response)
      } else if (response.status === 500) {
        // Exibir mensagem amigável para erros 500
        useCombinedStore
          .getState()
          .setMessageZustand("Erro no servidor. Tente novamente mais tarde.", "error");
      }
    } else {
      // Retornar o erro para ser tratado pelos componentes
      return Promise.reject(error);
    }
  }
);

export default api;
